export default {
  title: 'Page introuvable',
  message: 'Nous sommes désolés! La page que vous cherchez a peut-être été déplacée ou supprimée.',
  notFoundButton: 'Aller à l’accueil',
};
